<template>
    <div class="page center-registration-page">
        <v-container class="content-container">
            <div v-if="loading" class="d-flex justify-center align-center py-16">
                <v-progress-circular indeterminate color="primary" size="48" />
            </div>

            <template v-else-if="error">
                <div class="d-flex justify-center py-8">
                    <v-card flat class="transparent" style="max-width: 600px" width="100%">
                        <v-card-text class="text-center px-0">
                            <v-icon size="64" color="error" class="mb-4">mdi-alert-circle-outline</v-icon>
                            <h2 class="font-weight-bold strong-text--text mb-3">{{ error }}</h2>
                            <p class="details-text muted--text mb-8">تعذر فتح استمارة التسجيل</p>
                            <v-btn depressed color="primary" to="/home">العودة للرئيسية</v-btn>
                        </v-card-text>
                    </v-card>
                </div>
            </template>

            <template v-else-if="form">
                <section class="my-5 my-lg-8">
                    <h1 class="font-weight-bold primary--text headline d-flex justify-center align-center mb-8">
                        <v-icon size="32" color="primary" class="me-3">mdi-file-document-edit-outline</v-icon>
                        <span>{{form.name}}</span>
                    </h1>

                    <div class="d-flex justify-center">
                        <v-card class="transparent" style="max-width: 700px" flat width="100%">
                            <v-card-text class="pb-3 px-lg-8 px-0 pt-0">
                                <v-card outlined class="mb-10 rounded-lg">
                                    <v-card-text>
                                        <v-list class="py-0 px-3 transparent">
                                            <v-list-item class="px-0">
                                                <v-list-item-icon class="me-3">
                                                    <v-icon color="primary">mdi-map-marker-outline</v-icon>
                                                </v-list-item-icon>
                                                <v-list-item-content>
                                                    <v-list-item-subtitle>السنتر</v-list-item-subtitle>
                                                    <v-list-item-title class="font-weight-semibold">{{ form.local_center.name }}</v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-list-item class="px-0">
                                                <v-list-item-icon class="me-3">
                                                    <v-icon color="primary">mdi-account-tie-outline</v-icon>
                                                </v-list-item-icon>
                                                <v-list-item-content>
                                                    <v-list-item-subtitle>المدرس</v-list-item-subtitle>
                                                    <v-list-item-title class="font-weight-semibold">{{ form.teacher ? form.teacher.name : '---' }}</v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-list-item class="px-0">
                                                <v-list-item-icon class="me-3">
                                                    <v-icon color="primary">mdi-school-outline</v-icon>
                                                </v-list-item-icon>
                                                <v-list-item-content>
                                                    <v-list-item-subtitle>الصف الدراسي</v-list-item-subtitle>
                                                    <v-list-item-title class="font-weight-semibold">{{ form.grade.name }}</v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list>
                                    </v-card-text>
                                </v-card>

                                <v-alert
                                    v-if="registration && registration.status === 'pending'"
                                    type="info"
                                    icon="mdi-progress-clock"
                                    color="primary"
                                    prominent
                                    text
                                    class="mb-8"
                                >
                                    <h3 class="strong-text--text font-weight-bold mb-1">طلبك قيد المراجعة</h3>
                                    <div class="muted--text">تم إرسال طلب التسجيل بنجاح ونقوم حالياً بمراجعته.</div>
                                </v-alert>

                                <v-alert
                                    v-if="registration && registration.status === 'accepted'"
                                    type="success"
                                    prominent
                                    text
                                    class="mb-8"
                                >
                                    <h3 class="text--darken-1 success--text font-weight-bold mb-1">تم قبول طلب التسجيل</h3>
                                    <div class="text--text details-text">تم قبول طلب تسجيلك في السنتر بنجاح.</div>
                                </v-alert>

                                <v-alert
                                    v-if="registration && registration.status === 'rejected'"
                                    type="error"
                                    prominent
                                    text
                                    class="mb-8"
                                >
                                    <h3 class="text--darken-1 error--text font-weight-bold mb-1">تم رفض طلب التسجيل</h3>
                                    <div class="details-text">{{ registration.rejection_reason }}</div>
                                </v-alert>

                                <div v-if="registration && registration.status !== 'rejected'" class="mb-8">
                                    <v-list class="grey lighten-4 rounded-lg pa-2">
                                        <v-list-item>
                                            <v-list-item-icon>
                                                <v-icon>mdi-account-outline</v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-content>
                                                <v-list-item-subtitle>الاسم</v-list-item-subtitle>
                                                <v-list-item-title>{{ registration.name }}</v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-list-item>
                                            <v-list-item-icon>
                                                <v-icon>mdi-barcode</v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-content>
                                                <v-list-item-subtitle>كود السنتر</v-list-item-subtitle>
                                                <v-list-item-title>{{ registration.center_code }}</v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-list-item v-if="registration.status === 'accepted' && user && user.center_id">
                                            <v-list-item-icon>
                                                <v-icon color="success">mdi-identifier</v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-content>
                                                <v-list-item-subtitle>ID السنتر الخاص بك</v-list-item-subtitle>
                                                <v-list-item-title class="font-weight-bold success--text">{{ user.center_id }}</v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list>
                                </div>

                                <v-form
                                    v-if="canSubmit"
                                    ref="form"
                                    @submit.prevent="submit"
                                >
                                    <v-row>
                                        <v-col cols="12" class="pb-1 pt-0 mb-3">
                                            <v-text-field
                                                v-model="name"
                                                label="الاسم"
                                                placeholder="أدخل اسمك بالكامل"
                                                name="name"
                                                outlined
                                                hide-details="auto"
                                                :disabled="submitting || registration && registration.disabled"
                                                :rules="[rules.required, rules.nameMin, rules.nameMax]"
                                                prepend-inner-icon="mdi-account-outline"
                                            />
                                        </v-col>
                                        <v-col cols="12" class="pb-1 pt-0">
                                            <v-text-field
                                                v-model="center_code"
                                                placeholder="أدخل كود السنتر"
                                                name="center_code"
                                                outlined
                                                hide-details="auto"
                                                :disabled="submitting || registration && registration.disabled"
                                                :rules="[rules.required, rules.centerCodeMax]"
                                            />
                                        </v-col>
                                        <v-col cols="12" class="d-flex">
                                            <v-btn
                                                type="submit"
                                                depressed
                                                color="primary"
                                                large
                                                block
                                                :loading="submitting"
                                                :disabled="submitting || registration && registration.disabled"
                                                @click.prevent="submit"
                                            >
                                                {{ registration && registration.status === 'rejected' ? 'إعادة إرسال الطلب' : 'تأكيد التسجيل' }}
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-card-text>
                        </v-card>
                    </div>
                </section>
            </template>
        </v-container>
    </div>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    name: 'center-registration',

    props: {
        form_id: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            loading: true,
            submitting: false,
            error: null,
            form: null,
            registration: null,
            name: '',
            center_code: '',
            rules: {
                required: value => !!value || 'لا يمكنك ترك الحقل فارغاً',
                nameMin: value => (value && value.length >= 3) || 'يجب أن لا يقل الاسم عن 3 أحرف',
                nameMax: value => (value && value.length <= 100) || 'يجب أن لا يزيد الاسم عن 100 حرف',
                centerCodeMax: value => (value && value.length <= 255) || 'يجب أن لا يزيد كود السنتر عن 255 حرفاً',
            },
        };
    },

    computed: {
        canSubmit() {
            return !this.registration || this.registration.status === 'rejected';
        },
        ...GlobalComputed,
    },

    watch: {
        loading(loading) {
            this.setLinearLoading(loading);
        },
    },

    methods: {
        extractErrorMessage(error) {
            if (error.response && error.response.status === 422 && error.response.data.errors) {
                const errors = error.response.data.errors;
                const firstKey = Object.keys(errors)[0];
                return errors[firstKey][0];
            }
            return null;
        },

        loadForm() {
            this.loading = true;
            this.error = null;

            const url = `/center-registrations/${this.form_id}`;

            return this.$store.dispatch('fastGetAction', { url }).then(response => {
                const data = response.data;
                this.form = data.form;
                this.registration = data.registration;

                if (this.registration) {
                    this.name = this.registration.name;
                    this.center_code = this.registration.center_code;
                } else {
                    this.name = data.name || '';
                    this.center_code = '';
                }

                if (this.registration && this.registration.status === 'accepted') {
                    this.refreshUser();
                }
            }).catch(error => {
                if (error.response && error.response.status === 404) {
                    this.$router.replace({ name: 'not-found' });
                    return;
                }

                const message = this.extractErrorMessage(error);
                if (message) {
                    this.error = message;
                } else {
                    this.error = 'حدثت مشكلة أثناء تحميل استمارة التسجيل';
                }
            }).finally(() => {
                this.loading = false;
            });
        },

        refreshUser() {
            return this.$store.dispatch('checkAuth').catch(() => {});
        },

        formValidate() {
            return this.$refs.form ? this.$refs.form.validate() : false;
        },

        submit() {
            if (!this.formValidate() || this.submitting) {
                return;
            }

            this.submitting = true;

            const url = `/center-registrations/${this.form_id}`;
            const data = {
                name: this.name,
                center_code: this.center_code,
            };

            this.$store.dispatch('fastPostAction', { url, data }).then(response => {
                this.registration = response.data.registration;
                this.showMsg('تم إرسال طلب التسجيل بنجاح', 'success');
            }).catch(error => {
                const message = this.extractErrorMessage(error);
                if (message) {
                    this.showMsg(message);
                } else {
                    this.showMsg('حدثت مشكلة أثناء إرسال طلب التسجيل');
                }
            }).finally(() => {
                this.submitting = false;
            });
        },

        ...GlobalMethods,
    },

    created() {
        if (!this.appData || !this.appData.enable_center_registrations) {
            this.$router.replace({ name: 'not-found' });
            return;
        }

        this.loadForm();
    },
};
</script>
